export const CloudCProps = {
  bodyShape: `M68.3,237.2c-6.9,2.3-14.4,4.5-21.6,7.2
  C24.6,252.7,8,266.9,2.4,290.6c-2.3,9.7-2.1,20.1-2.4,30.3
  c-0.2,7.3,1.2,7.8,8.2,7.1c14-1.4,28-3.2,42-3.6c22.4-0.6,44.8-0.3,67.1-0.2
  c13.2,0,26.5,0,39.7,0.3c12.1,0.2,24.1,1.2,36.2,1.1c19.5-0.1,39-1,58.5-1
  c23,0,46,0.5,69,0.9c25.2,0.4,50.5,0.4,75.7,1.2c29.6,1,59.3,3.4,88.9,3.7
  c20.7,0.2,41.4-2.4,62.1-3.3c20.1-0.9,40.3-0.9,60.4-2.1
  c12.3-0.8,24.5-3.1,36.8-4.9c1.3-0.2,3.5-2,3.5-3c-0.3-8.8-0.5-17.6-1.7-26.2
  c-3.7-25.8-15.6-38.2-40.8-42.1c-11.3-1.7-22.9-1.6-34.1-2.4
  c-2.9-12.1-6-24-8.4-36.1c-1.9-9.6-6-18-11.8-25.6
  c-12.2-16.1-26.4-29.3-47.5-32.5c-11.6-1.8-23.2-3.8-33.9-5.5
  c-2.7-13.9-5-28.7-8.7-43.2c-2.3-8.9-6.7-17.2-10.4-25.7
  c-7.7-17.7-18.6-33-33.4-45.6c-16.2-13.7-35.8-19.7-55.4-25.9
  c-24.5-7.7-49.7-8-74.2-3c-34.7,7-64.6,23.8-86.4,52.6
  c-12.9,17-24.3,34.9-26.6,56.9c-0.5,4.8-1.2,9.5-1.8,14.4
  c-1.7,0.3-3.2,0.8-4.8,0.9c-18.6,1-35.8,7.3-52.3,15.3
  c-22.4,10.9-38.1,28.3-43,53.3C70,209.8,69.7,223.4,68.3,237.2`,
  outlineShape: `M463.4,153.4c-0.5-8.7-0.9-16.4-1.5-24.1
  c-1.4-18.2-10-34.2-16.7-50.7C438.7,62.8,429,49,416,38
  c-22.3-18.9-48.9-28.4-77.4-31.7c-25.5-2.9-50.8-0.9-75.1,8.6
  c-24.1,9.4-44,24.7-59.7,44.7c-15.6,19.9-27.3,42-25.1,68.7
  c0.1,1.2-0.5,2.5-0.7,3.3c-7.9,0.9-15.7,0.7-22.7,2.8c-13.5,4-27,8.4-39.9,14.1
  c-18.2,8-30.7,22.4-36.9,41.1c-4.3,13-6.5,26.6-4.9,40.5c0.3,2.9,0.5,5.9,0,8.6
  c-0.3,1.6-2.1,3.7-3.6,4.2c-4.2,1.3-8.6,1.6-12.8,2.7c-23.8,6-41.8,18.7-49.7,43
  c-3.6,11.1-4.4,22.4-2.3,34.2c3.2,0,5.9,0.2,8.5,0c10.9-1.2,21.9-3.5,32.8-3.7
  c23-0.3,46,0.6,69,1c14.6,0.2,29.2,0.1,43.7,0.5c9.7,0.3,19.4,2,29.1,1.9
  c19-0.1,38-1.5,57-1.6c24.5-0.1,49,0.3,73.6,0.7c26.3,0.4,52.6,0.5,78.9,1.4
  c24.2,0.8,48.3,3.3,72.5,3.6c21.4,0.2,42.8-1.4,64.1-2.6
  c19.4-1.1,38.8-2.9,58.2-3.8c11-0.5,22-0.1,32.7-3.9c3.7-1.3,7.9-1.5,11.8-1.4
  c4.6,0.1,5.5-2.1,5.8-6c1.4-16.2-3.8-30.7-12.3-43.9c-2.3-3.5-6.9-6.1-11.1-7.7
  c-14.5-5.7-29.8-6.5-45.1-5.4c-6,0.4-7.9-1.7-9-7.5c-3.5-18.5-5.1-37.6-15.7-54.3
  c-17.1-27-45.1-40-80.2-36.7C467.3,153.8,465.3,153.5,463.4,153.4 M68.3,237.2
  c1.4-13.9,1.7-27.4,4.3-40.6c4.9-25,20.5-42.4,43-53.3
  c16.4-8,33.7-14.3,52.3-15.3c1.5-0.1,3-0.6,4.8-0.9c0.6-4.9,1.3-9.6,1.8-14.4
  c2.4-22,13.8-39.9,26.6-56.9c21.8-28.7,51.7-45.5,86.4-52.6
  c24.6-5,49.7-4.7,74.2,3c19.6,6.1,39.2,12.1,55.4,25.9
  c14.8,12.6,25.7,27.9,33.4,45.6c3.7,8.5,8.1,16.9,10.4,25.7
  c3.7,14.5,6,29.3,8.7,43.2c10.7,1.7,22.3,3.7,33.9,5.5
  c21.1,3.2,35.3,16.4,47.5,32.5c5.8,7.7,9.9,16,11.8,25.6
  c2.4,12.1,5.6,24,8.4,36.1c11.2,0.7,22.8,0.6,34.1,2.4
  c25.3,3.8,37.1,16.3,40.8,42.1c1.2,8.6,1.4,17.5,1.7,26.2
  c0,1-2.2,2.7-3.5,3c-12.2,1.8-24.4,4.2-36.8,4.9c-20.1,1.2-40.3,1.2-60.4,2.1
  c-20.7,0.9-41.4,3.5-62.1,3.3c-29.6-0.3-59.3-2.7-88.9-3.7
  c-25.2-0.8-50.4-0.8-75.7-1.2c-23-0.3-46-0.9-69-0.9c-19.5,0-39,1-58.5,1
  c-12.1,0-24.1-0.9-36.2-1.1c-13.2-0.3-26.5-0.3-39.7-0.3
  c-22.4,0-44.8-0.4-67.1,0.2c-14,0.4-28,2.1-42,3.6c-7,0.7-8.4,0.2-8.2-7.1
  c0.3-10.1,0.1-20.5,2.4-30.3c5.6-23.8,22.2-37.9,44.3-46.2
  C53.9,241.7,61.4,239.5,68.3,237.2`
}



// WEBPACK FOOTER //
// ./src/components/animatedIcons/defaultProps.js